// extracted by mini-css-extract-plugin
export default {"box":"PreviewBox_box__OrUMO"};